export default function Logo({ invertiert = false, className = "" }) {
  return (
    <img
      src="/2besales-logo.webp"
      alt="2besales"
      className={`h-8 w-auto ${invertiert ? "invert" : ""} ${className}`}
      data-testid="logo-2besales"
    />
  );
}
